import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../images/logo.png'

function Header() {
  const { t } = useTranslation();

  return (
    <header className="site-header">
      <nav className="navbar">
        <a href="#top" className="brand" aria-label={t('company.homepageAria')}>
          <img src={ logo } alt="WillowTec logo" className="brand-logo" />

          <span>{t('company.name')}</span>
        </a>

        <div className="nav-actions">
          <div className="nav-links">
            <a href="#services">{t('nav.services')}</a>
            <a href="#technology">{t('nav.technology')}</a>
            <a href="#rails">{t('nav.rails')}</a>
            <a href="#solutions">{t('nav.solutions')}</a>
            <a href="#flexibility">{t('nav.flexibility')}</a>
            <a href="#process">{t('nav.process')}</a>
            <a href="#contact" className="nav-cta">
              {t('nav.contact')}
            </a>
          </div>

          <LanguageSwitcher />
        </div>
      </nav>
    </header>
  );
}

export default Header;